module.exports = __webpack_public_path__ + "img/yidong.9a4be2ce.png";